module.exports = __webpack_public_path__ + "static/workshop1-7c124ce28965cb5f5199298604632be6.jpg";